import cityPicker from '../backend/_city_picker';
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "output", "submit"]

  connect () {
    const input = this.inputTarget
    const output = this.outputTarget

    new cityPicker({
      input: input,
      output: output,
      onFirstSuggestion: (suggestion) => {
        this.firstSuggestion = suggestion
      }
    })

    this.disableEnterKey(input)
  }

  submit (event) {
    if (this.firstSuggestion && !this.outputTarget.value) {
      // Fill in the hidden field with the first suggestion
      this.outputTarget.value = this.firstSuggestion.city.id
    }
  }

  disableEnterKey (input) {
    input.addEventListener("keypress", function(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
      }
    });
  }
}
